module.exports = __webpack_public_path__ + "assets/img/33_844_big.1a49c0f0.jpg";